import { Component } from 'react';
import PostsIcon from '../icons/posts_icon';
import classes from './separator.less';

export default class Separator extends Component {
  render() {
    return (
      <div className={classes.line}>
        <div className={classes.text}>
          <PostsIcon />
          POSTS
        </div>
      </div>
    );
  }
}
